import React from 'react';

import { useSelector } from 'react-redux';

const QuoterSummary = () => {
  const previousSteps = 3;
  const totalSteps = useSelector((state) => state.appConfig.quoterTotalSteps) - previousSteps;
  const quoterCurrentStep = useSelector((state) => state.appConfig.quoterCurrentStep) - previousSteps;
  const postalCode = useSelector((state) => state.landingPage.postalCode);
  const brand = useSelector((state) => state.form2.brand);
  const subbrand = useSelector((state) => state.form2.subbrand);
  const model = useSelector((state) => state.form2.model);
  const version = useSelector((state) => state.form2.version);
  const planName = useSelector((state) => state.form3.planName);
  const periodicity = useSelector((state) => state.form3.selectedPeriodicity);
  const firstPayment = useSelector((state) => state.form3.firstPayment);
  const paymentAmount = useSelector((state) => state.form3.paymentAmount);
  const totalPayment = useSelector((state) => state.form3.totalPayment);
  const dropdownOpen = true;
  const dropdownClasses = !dropdownOpen ? 'quoter-summary' : 'quoter-summary -open';

  return (
    quoterCurrentStep <= totalSteps && (
      <div className={dropdownClasses}>
        <button type="button" className="toggle">
          Resumen de Cobertura&nbsp;
          {planName}
        </button>
        <div className="body">
          <div className="summary-panel">
            <p>Plan</p>
            <p>
              Forma de pago:&nbsp;
              <strong>{periodicity}</strong>
            </p>
            {periodicity.toLowerCase() !== 'anual' && (
              <p>
                Primer recibo:&nbsp;
                <strong>{firstPayment}</strong>
              </p>
            )}
            {periodicity.toLowerCase() !== 'anual' && (
              <p>
                Pagos subsecuentes:&nbsp;
                <strong>{paymentAmount}</strong>
              </p>
            )}
            <p>
              Total a pagar:&nbsp;
              <strong>{`$${totalPayment}`}</strong>
            </p>
          </div>
          <div className="summary-panel">
            <p>Vehículo</p>
            <p>
              Marca: &nbsp;
              <strong>{brand}</strong>
            </p>
            <p>
              Submarca: &nbsp;
              <strong>{subbrand}</strong>
            </p>
            <p>
              Modelo: &nbsp;
              <strong>{model}</strong>
            </p>
            <p>
              Versión: &nbsp;
              <strong>{version}</strong>
            </p>
          </div>
          <div className="summary-panel">
            <p>Conductor:</p>
            <p>
              Código Postal:&nbsp;
              <strong>{postalCode}</strong>
            </p>
          </div>
        </div>
      </div>
    )
  );
};

export default QuoterSummary;
